import axios from 'axios';
import { checkAxiosError, getRootUrl } from 'utilities';
import { AuthorizationData, SigninData } from './entities';

export const authorization = async (authorizationData: AuthorizationData): Promise<SigninData> => {
    const response = await axios.post(`${getRootUrl()}api/v2/session/signin`, authorizationData);

    checkAxiosError(response);

    let result = response.data;
    result.sessionId = response.headers['sessionid'];

    return result;
};

export const getConfig = async (): Promise<boolean> => {
    const response = await axios.get<boolean>(`${getRootUrl()}api/v2/haveconfig`);
    checkAxiosError(response);    

    return response.data;
};